import React, { useState } from "react";
import { X } from "lucide-react";
import Modal from "./Modal";
import FormField from "@/components/FormField";
import Button from "@/components/Button";

export default function EditSchoolModal({ school, onClose, onSave }) {
  const [form, setForm] = useState({
    school_name: school.school_name,
    city: school.city,
    state: school.state || "",
    coordinator_name: school.coordinator_name,
    coordinator_mobile: school.coordinator_mobile,
    coordinator_email: school.coordinator_email,
    grades_participating: school.grades_participating || "",
    expected_entries: String(school.expected_entries ?? ""),
  });
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await onSave({
        ...form,
        expected_entries: parseInt(form.expected_entries || "0", 10),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal onClose={onClose} size="md" testid="edit-school-modal">
      <div className="flex items-start justify-between gap-4 mb-4">
        <h3 className="text-lg sm:text-xl font-extrabold text-sprouts-text">Edit School</h3>
        <button
          type="button"
          onClick={onClose}
          data-testid="edit-modal-close"
          className="p-1.5 rounded-md hover:bg-slate-100"
          aria-label="Close"
        >
          <X size={22} />
        </button>
      </div>
      <FormField
        label="School Name"
        value={form.school_name}
        onChange={(e) => setForm({ ...form, school_name: e.target.value })}
        data-testid="edit-school-name"
      />
      <FormField label="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
      <FormField label="State" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} />
      <FormField
        label="Coordinator Name"
        value={form.coordinator_name}
        onChange={(e) => setForm({ ...form, coordinator_name: e.target.value })}
      />
      <FormField
        label="Mobile"
        value={form.coordinator_mobile}
        onChange={(e) => setForm({ ...form, coordinator_mobile: e.target.value })}
      />
      <FormField
        label="Email"
        autoCapitalize="none"
        value={form.coordinator_email}
        onChange={(e) => setForm({ ...form, coordinator_email: e.target.value })}
      />
      <FormField
        label="Grades"
        value={form.grades_participating}
        onChange={(e) => setForm({ ...form, grades_participating: e.target.value })}
      />
      <FormField
        label="Expected Entries"
        inputMode="numeric"
        value={form.expected_entries}
        onChange={(e) => setForm({ ...form, expected_entries: e.target.value.replace(/[^0-9]/g, "") })}
      />
      <Button onClick={submit} loading={saving} data-testid="edit-save" fullWidth>
        {saving ? "Saving..." : "Save Changes"}
      </Button>
    </Modal>
  );
}
